var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-2 pb-1" },
    [
      _c(
        "div",
        { staticClass: "font-bold tracking-widest text-lg md_text-sm" },
        [_vm._v("TREND")]
      ),
      _vm._l(_vm.visibleCategories, function(categoryObj) {
        return _c("buyer-checkbox", {
          key: categoryObj.id,
          staticClass:
            "text-brand-secondary-850 cursor-pointer hover_underline mt-_75",
          attrs: {
            small: _vm.$mq === "sm" || _vm.$mq === "md" ? false : true,
            label: categoryObj.category,
            model: categoryObj === _vm.selectedCategory,
            value: true
          },
          on: {
            input: function($event) {
              return _vm.handleSelectCategory(categoryObj)
            }
          }
        })
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.selectedCategories.length - _vm.selectedCategoryIndex > 0,
              expression:
                "selectedCategories.length - selectedCategoryIndex > 0"
            }
          ],
          staticClass:
            "text-sm text-brand-secondary-400 mt-1 ml-1_75 cursor-pointer hover_underline inline-block",
          attrs: { tabindex: "0" },
          on: {
            click: function($event) {
              _vm.showAll = !_vm.showAll
            },
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              _vm.showAll = !_vm.showAll
            }
          }
        },
        [
          _vm.showAll
            ? _c("span", [_vm._v("Less")])
            : _c("span", [
                _vm._v(
                  "+" +
                    _vm._s(
                      _vm.selectedCategories.length - _vm.selectedCategoryIndex
                    ) +
                    " More"
                )
              ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }